import React, { ChangeEvent, useContext, useState } from "react";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import SupplierService from "../../../services/SupplierService";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    closeModalFn: () => void;
    onCancelFn: (cancelReason: string, sendEmail: boolean) => void;
};

export const OrderCancelledModal = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const [onCancelReason, setOnCancelReason] = useState("");
    const [sendEmail, setSendEmail] = useState(false);

    const closeModal = () => {
        props.closeModalFn();
    };

    const submitOnHold = () => {
        props.onCancelFn(onCancelReason, sendEmail);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "cancel_reason":
                setOnCancelReason(value);
                break;

            case "send_email":
                setSendEmail(value);
                break;
        }
    };

    return (
        <div className={"OrderCancelledModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle title={SupplierService.updateStringWithOrderNameOverride("cancel_order", supplierModel)} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwLabel title={"cancel_reason"} />
                    <OwTextArea fn={handleChange} name={"cancel_reason"} value={onCancelReason} />
                </div>

                <div className={"mt-4"}>
                    <OwCheckbox
                        name={"send_email"}
                        fn={handleChange}
                        checked={sendEmail}
                        truthyVal={true}
                        falsyVal={false}
                        label={"send_email"}
                    />
                </div>
            </div>

            <div className={"mt-4"}>
                <OwButton title={"submit"} fn={submitOnHold} />
            </div>
        </div>
    );
};
